import React from 'react'
import styles from './AdminTable.module.css'

function AdminTable({ children }) {
    // Get the number of rows in tbody
    const tbody = React.Children.toArray(children).find(
        child => child.type === 'tbody'
    )

    // Filter out the ref row (last row) when counting records
    const tbodyChildren = React.Children.toArray(tbody.props.children)
    const totalRecords = tbodyChildren.filter(child => {
        // Check if this child has a ref prop (the infinite scroll row)
        return !child.props || !child.props.ref
    }).length

    return (
        <>
            <div className={`table-responsive ${styles.tableContainer}`}>
                <table className="table table-hover text-nowrap">
                    {children}
                </table>
            </div>
            <div className="d-flex justify-content-end mt-3">
                <p className="text-muted">
                    Total Records: {totalRecords}
                </p>
            </div>
        </>
    )
}

export default AdminTable 